var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.99935C2 5.26297 2.59695 4.66602 3.33333 4.66602H3.95309C4.39889 4.66602 4.8152 4.44321 5.06249 4.07228L5.60418 3.25975C5.85147 2.88882 6.26777 2.66602 6.71358 2.66602H9.28642C9.73223 2.66602 10.1485 2.88882 10.3958 3.25975L10.9375 4.07228C11.1848 4.44321 11.6011 4.66602 12.0469 4.66602H12.6667C13.403 4.66602 14 5.26297 14 5.99935V11.9993C14 12.7357 13.403 13.3327 12.6667 13.3327H3.33333C2.59695 13.3327 2 12.7357 2 11.9993V5.99935Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.66602C10 9.77059 9.10457 10.666 8 10.666C6.89543 10.666 6 9.77059 6 8.66602C6 7.56145 6.89543 6.66602 8 6.66602C9.10457 6.66602 10 7.56145 10 8.66602Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6535f21114d33ebc9ee7e8b1efa8f8c2.svg";
export { ForwardRef as ReactComponent };